/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MomentModule} from 'ngx-moment';

import {ESSService} from '../+ess/employee-self.service';
import {Validators} from '../shared/forms/common-validators';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';

import {MyProfileComponent} from './my-profile.component';
import {ProfileDrawerComponent} from './profile-drawer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    ModalModule,
    UserModule,
    TranslateModule,
    UiModule,
    PipesModule
  ],
  declarations: [
    MyProfileComponent,
    ProfileDrawerComponent
  ],
  exports: [
    MyProfileComponent,
    ProfileDrawerComponent
  ],
  providers: [
    Validators,
    ESSService
  ]
})
export class MeModule {
}
